import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IYonetimSehirKart_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYonetimSehirKart_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  Get_Helpers_LoginUserInfo: any[];
  Get_Helpers_LoginUserInfo_dummy: any[];
  Get_Yonetim_UlkeListe: any[];
  Get_Yonetim_UlkeListe_dummy: any[];
  Get_Yonetim_SehirById: any[];
  Get_Yonetim_SehirById_dummy: any[];
  ChangeEnabledOf: any;
  ChangeEnabledOf_dummy: any;
  GoBack: any;
  GoBack_dummy: any;
  Add_Yonetim_Sehir: number;
  Add_Yonetim_Sehir_dummy: number;
  isComp503860Enabled: "enabled" | "disabled";
}

export class YonetimSehirKart_ScreenBase extends React.PureComponent<
  IYonetimSehirKart_ScreenProps,
  any
> {
  yonetimsehirkart_77019_value_kuikaSelectBoxRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ac10076f-ce42-4204-85b5-6b030950b490",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 891214,
          PropertyName: "value",
          Value: "ŞEHİR EKLEME - DÜZENLEME",
        },
        { Id: 249608, PropertyName: "value", Value: "Şehir Kodu" },
        { Id: 503860, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 821217, PropertyName: "value", Value: "Şehir Adı" },
        { Id: 65269, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 44144, PropertyName: "value", Value: "Ülke" },
        { Id: 77019, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 974814, PropertyName: "label", Value: "Vazgeç" },
        { Id: 865072, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.yonetimsehirkart_503860_value_kuikaTextInputRef = React.createRef();
    this.yonetimsehirkart_65269_value_kuikaTextInputRef = React.createRef();
    this.yonetimsehirkart_77019_value_kuikaSelectBoxRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      Get_Helpers_LoginUserInfo: [],
      Get_Yonetim_UlkeListe: [],
      Get_Yonetim_SehirById: [],
      ChangeEnabledOf: "",
      GoBack: "",
      Add_Yonetim_Sehir: 0,
      isComp503860Enabled: "enabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("yonetimsehirkart", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.YonetimSehirKartPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("yonetimsehirkart", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("yonetimsehirkart", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YonetimSehirKartPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YonetimSehirKartPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YonetimSehirKart/YonetimSehirKartPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_LoginUserInfo =
      result?.data.get_Helpers_LoginUserInfo;
    stateVars.Get_Yonetim_UlkeListe = result?.data.get_Yonetim_UlkeListe;

    formVars.yonetimsehirkart_77019_options = stateVars.Get_Yonetim_UlkeListe;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YonetimSehirKartPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YonetimSehirKartPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      SehirId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.SehirId ?? this.props.screenInputs.sehirid,
        "Guid"
      ),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SehirId ?? this.props.screenInputs.sehirid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YonetimSehirKart/YonetimSehirKartPageInit1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Get_Yonetim_SehirById = result?.data.get_Yonetim_SehirById;
      formVars.yonetimsehirkart_503860_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Yonetim_SehirById !== undefined
          ? stateVars.Get_Yonetim_SehirById?.length > 0
            ? stateVars.Get_Yonetim_SehirById[0].sehirKodu
            : null
          : this.state.Get_Yonetim_SehirById?.length > 0
          ? this.state.Get_Yonetim_SehirById[0].sehirKodu
          : null
      );
      formVars.yonetimsehirkart_65269_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Yonetim_SehirById !== undefined
          ? stateVars.Get_Yonetim_SehirById?.length > 0
            ? stateVars.Get_Yonetim_SehirById[0].sehirAdi
            : null
          : this.state.Get_Yonetim_SehirById?.length > 0
          ? this.state.Get_Yonetim_SehirById[0].sehirAdi
          : null
      );
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimSehirKartPageInit2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimSehirKartPageInit2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YonetimSehirKartPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SehirId ?? this.props.screenInputs.sehirid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      stateVars.ChangeEnabledOf = await ReactSystemFunctions.changeEnabledOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp503860Enabled",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("disabled", "string")
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimSehirKartPageInit3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimSehirKartPageInit3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YonetimSehirKartPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SehirId ?? this.props.screenInputs.sehirid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.yonetimsehirkart_503860_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Yonetim_SehirById !== undefined
          ? stateVars.Get_Yonetim_SehirById?.length > 0
            ? stateVars.Get_Yonetim_SehirById[0].sehirKodu
            : null
          : this.state.Get_Yonetim_SehirById?.length > 0
          ? this.state.Get_Yonetim_SehirById[0].sehirKodu
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimSehirKartPageInit4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimSehirKartPageInit4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YonetimSehirKartPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.SehirId ?? this.props.screenInputs.sehirid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.yonetimsehirkart_65269_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Yonetim_SehirById !== undefined
          ? stateVars.Get_Yonetim_SehirById?.length > 0
            ? stateVars.Get_Yonetim_SehirById[0].sehirAdi
            : null
          : this.state.Get_Yonetim_SehirById?.length > 0
          ? this.state.Get_Yonetim_SehirById[0].sehirAdi
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimSehirKartPageInit5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimSehirKartPageInit5_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YonetimSehirKartPageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_77019 =
      stateVars.Get_Yonetim_UlkeListe ?? this.state.Get_Yonetim_UlkeListe;
    stateVars.dataSource_77019 =
      stateVars.Get_Yonetim_UlkeListe ?? this.state.Get_Yonetim_UlkeListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YonetimSehirKartComponent_974814_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "43fc490a_712c_ab21_16b0_3731dcc99abb_confirmation",
        this.defaultML,
        "Kayıt edilmeyen veriler iptal edilecek"
      ),
      "poppins",
      "",
      "",
      "#246dff"
    );

    if (stateVars.Confirm) {
      KuikaAppManager.showSpinner(this);

      stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  YonetimSehirKartComponent_865072_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UlkeId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimsehirkart_77019_value",
            "value",
            "Get_Yonetim_UlkeListe",
            "ulkeKodu",
            "id"
          )
        ),
        "Guid"
      ),
      SehirKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimsehirkart_503860_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SehirAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimsehirkart_65269_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YonetimSehirKart/YonetimSehirKartComponent_865072_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Add_Yonetim_Sehir = result?.data.add_Yonetim_Sehir;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YonetimSehirKartComponent_865072_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YonetimSehirKartComponent_865072_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YonetimSehirKartPageInit();
    }
  }
}
